import React from "react";
import { ChildSafety } from "../../components/child-safety/child-safety.component";

export const ChildSafetyPage = () => {
  return <ChildSafety />;
};

